// Helper function to format Swedish numbers with space as thousands separator
function formatSwedishNumber(number) {
  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function responseHandler(data, status, path) {
  if (status >= 200 && status < 300) return data;
  console.error("Foxway API error", { status, path, data });
  return null;
}

async function fetchRework(path) {
  let resStatus = 0;

  const baseUrl = "https://old.macforum.se";
  const url = `${baseUrl}/api/v2/rework?path=${path}`;

  try {
    const response = await fetch(url, {
      method: "GET",
    });

    resStatus = response.status;
    const data = await response.json();
    return responseHandler(data, resStatus, path);
  } catch (error) {
    console.error(error);
  }
}

async function postRework(path, payload) {
  let resStatus = 0;

  const baseUrl = "https://old.macforum.se";
  const url = `${baseUrl}/api/v2/rework?path=${path}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    resStatus = response.status;
    const data = await response.json();
    return responseHandler(data, resStatus, path);
  } catch (error) {
    console.error(error);
  }
}

// ------- Update Cart with Trade-In Data -------
async function updateCartWithTradeInData(
  wrapper,
  updatedTradeInData,
  cartItemKey = null
) {
  try {
    // Find the cart item that contains this trade-in data
    const cartItems = await fetchCartItems();

    // Find the cart item
    let targetCartItem = null;

    // If cartItemKey is provided, use it directly
    if (cartItemKey) {
      targetCartItem = cartItems.find((item) => item.key === cartItemKey);
    } else {
      // Otherwise, try to find by trade-in data
      for (const item of cartItems) {
        if (item.properties && item.properties._trade_in_data) {
          try {
            const existingData = JSON.parse(item.properties._trade_in_data);
            if (existingData.macforum_trade_items) {
              targetCartItem = item;
              break;
            }
          } catch (e) {
            // Skip items with invalid JSON
          }
        }
      }

      // If still not found, try to extract cart item index from wrapper ID
      if (!targetCartItem && wrapper) {
        const wrapperId = wrapper.getAttribute("id");
        if (wrapperId && wrapperId.startsWith("CartItem-trade-in-")) {
          const index = wrapperId.replace("CartItem-trade-in-", "");
          // Find cart item by index (index is 1-based in the ID)
          const cartItemRow = document.getElementById(`CartItem-${index}`);
          if (cartItemRow) {
            // Try to find cart item by matching index
            const cartItemIndex = parseInt(index) - 1;
            if (cartItems[cartItemIndex]) {
              targetCartItem = cartItems[cartItemIndex];
            }
          }
        }
      }
    }

    if (!targetCartItem) {
      console.error("❌ Could not find cart item with trade-in data");
      return;
    }

    // Update the cart item with new trade-in data
    const updatedProperties = {
      ...targetCartItem.properties,
    };

    // If updatedTradeInData is null, set _trade_in_data to null, otherwise stringify it
    if (updatedTradeInData === null) {
      updatedProperties._trade_in_data = null;
      updatedProperties._trade_in_total = 0;
    } else {
      updatedProperties._trade_in_data = JSON.stringify(updatedTradeInData);
      // Store total trade-in value separately for easier access in other contexts
      updatedProperties._trade_in_total =
        (updatedTradeInData.macforum_trade_items &&
          Math.round(updatedTradeInData.macforum_trade_items.total || 0)) ||
        0;
    }

    // First remove the old item, then add it back with updated properties

    // Step 1: Remove the old item by setting quantity to 0
    const removeResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [targetCartItem.key]: 0,
        },
      }),
    });

    if (!removeResponse.ok) {
      const errorText = await removeResponse.text();
      console.error("❌ Cart remove failed:", removeResponse.status, errorText);
      throw new Error(
        `Cart remove failed: ${removeResponse.status} - ${errorText}`
      );
    }

    // Step 2: Add the item back with updated properties
    const requestBody = {
      id: targetCartItem.variant_id,
      quantity: targetCartItem.quantity,
      properties: updatedProperties,
    };

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Cart update failed:", response.status, errorText);
      throw new Error(`Cart update failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();

    // Wait a moment to ensure the cart update is processed
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Verify the update by fetching cart again
    const verifyCartItems = await fetchCartItems();
    const verifyItem = verifyCartItems.find(
      (item) => item.key === targetCartItem.key
    );

    return result;
  } catch (error) {
    console.error("❌ Error updating cart:", error);
    throw error;
  }
}

// ------- Fetch Cart Items -------
async function fetchCartItems() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }

    const cart = await response.json();

    return cart.items;
  } catch (error) {
    console.error("❌ Error fetching cart items:", error);
    throw error;
  }
}

// ------- Parse and render trade-in items from cart data -------
function parseAndRenderTradeInItems() {
  // Find all elements with trade-in data
  const tradeInWrappers = document.querySelectorAll(
    "[data-trade-in-item-json]"
  );

  if (tradeInWrappers.length === 0) {
    return;
  }

  tradeInWrappers.forEach((wrapper, wrapperIndex) => {
    const tradeInDataJson = wrapper.getAttribute("data-trade-in-item-json");

    if (!tradeInDataJson) {
      return;
    }

    try {
      const tradeInData = JSON.parse(tradeInDataJson);

      if (!tradeInData.macforum_trade_items) {
        return;
      }

      if (!tradeInData.macforum_trade_items.items) {
        return;
      }

      const items = tradeInData.macforum_trade_items.items;

      // Find the target td element inside the wrapper
      const targetTd = wrapper.querySelector(`[id^="trade-inline-item-"]`);

      if (!targetTd) {
        return;
      }

      // Clear existing content inside the target td
      targetTd.innerHTML = "";

      // Render each trade-in item
      items.forEach((item, index) => {
        const tradeInItemHtml = createTradeInItemHtml(item, index);
        targetTd.insertAdjacentHTML("beforeend", tradeInItemHtml);
      });
    } catch (error) {
      console.error(
        `❌ Wrapper ${wrapperIndex} - Error parsing trade-in data:`,
        error
      );
    }
  });

  // Update cart price displays after rendering trade-in items
  updateCartPriceDisplays();
}

function createTradeInItemHtml(item, index) {
  // Format the offered price with Swedish number formatting
  const formattedPrice = formatSwedishNumber(item.offeredPrice);

  // Get settings from existing elements or use defaults
  const removeBtnText =
    document.querySelector(".remove-btn")?.textContent || "Ta bort";

  const html = `
      <div class="cart_itemadd apl-section-cart-trade-in cart_item_trade_in trade-in-item-${index}">
        <div class="trade-in__card-img-info-title apple-care-img-info-title trade-in-content-container">
          <div class="trade-in__card-products-on-cart tradeincartgridchg applecarecartgridchg applecare-products-on-cart trade-in-content-wrapper">
            <div class="trade-in__card-item-img applecare-item-img apl-section-cart-trade-in-image">
              <svg xmlns="http://www.w3.org/2000/svg" width="43" height="34" fill="none" viewBox="0 0 43 34"><g clip-path="url(#a)"><mask id="b" fill="#fff"><path d="M41.82 10.078 32.397.72a2.496 2.496 0 0 0-3.51 0l-1.954 1.941a2.44 2.44 0 0 0-.727 1.743c0 .658.259 1.278.727 1.743l.188.187-2.541 2.524h-6.617l-2.542-2.523.188-.187a2.44 2.44 0 0 0 .727-1.743 2.44 2.44 0 0 0-.727-1.743L13.656.722a2.497 2.497 0 0 0-3.51 0l-9.42 9.356A2.44 2.44 0 0 0 0 11.821c0 .66.258 1.278.727 1.743l1.954 1.941c.484.48 1.12.72 1.755.72.636 0 1.271-.24 1.755-.72l.188-.187 2.541 2.525v2.26L7.86 21.25a1.84 1.84 0 0 0 .083 2.57l9.98 9.49c.347.33.799.51 1.278.51h.06a1.84 1.84 0 0 0 1.303-.593l.167-.18q.19-.207.331-.443.029.002.056.004a2.69 2.69 0 0 0 2.613-2.002c.465.35 1.029.541 1.624.541.722 0 1.4-.28 1.911-.786a2.66 2.66 0 0 0 .726-1.333 2.7 2.7 0 0 0 1.234.297c.722 0 1.401-.28 1.912-.787.73-.725.942-1.761.657-2.679a2.7 2.7 0 0 0 1.582-.764c.51-.508.791-1.182.791-1.9 0-.716-.28-1.39-.791-1.898l-.08-.08.305-3.347 2.566-2.55.188.187c.484.48 1.12.72 1.755.72.636 0 1.271-.24 1.755-.72l1.954-1.94a2.44 2.44 0 0 0 .726-1.744c0-.659-.258-1.277-.726-1.743zM5.22 14.54c-.433.43-1.137.43-1.57 0L1.698 12.6a1.094 1.094 0 0 1 0-1.558l9.42-9.358a1.116 1.116 0 0 1 1.57 0l1.953 1.941c.21.209.325.485.325.78 0 .294-.115.57-.325.778zm3.672 8.292a.474.474 0 0 1-.022-.663l1.663-1.797a1.38 1.38 0 0 1 1.011-.443 1.313 1.313 0 0 1 .97 2.21l-2.037 2.203zm2.577 2.451 2.643-2.857a1.34 1.34 0 0 1 1.881-.079 1.313 1.313 0 0 1 .08 1.869l-2.68 2.897zm2.915 2.772 1.726-1.866a1.34 1.34 0 0 1 1.88-.078 1.313 1.313 0 0 1 .08 1.869l-1.762 1.905zm5.334 4.066-.166.18a.47.47 0 0 1-.336.152.47.47 0 0 1-.345-.131L17.3 30.827l.44-.475c.506-.546 1.356-.593 1.896-.103.264.239.418.566.433.921.015.353-.11.69-.35.951m12.687-7.995c-.504.5-1.38.5-1.883 0l-2.032-2.018a.69.69 0 0 0-.97 0 .68.68 0 0 0 0 .964l2.645 2.628c.52.516.52 1.354 0 1.87-.503.5-1.38.5-1.883 0l-3.043-3.022a.69.69 0 0 0-.971 0 .68.68 0 0 0 0 .964l2.024 2.01c.52.516.52 1.355 0 1.87-.503.5-1.38.5-1.883 0l-2.324-2.308a.69.69 0 0 0-.97 0 .68.68 0 0 0 0 .964l.942.936c.25.25.388.58.388.933a1.31 1.31 0 0 1-1.01 1.278q.002-.041 0-.083a2.66 2.66 0 0 0-.88-1.871 2.65 2.65 0 0 0-1.251-.624 2.65 2.65 0 0 0 .484-1.646 2.66 2.66 0 0 0-.873-1.864 2.7 2.7 0 0 0-1.371-.663 2.66 2.66 0 0 0 .246-1.238 2.66 2.66 0 0 0-.873-1.863 2.71 2.71 0 0 0-2.724-.543 2.66 2.66 0 0 0-.84-1.538c-.854-.775-2.082-.888-3.065-.385V17.56a.68.68 0 0 0-.201-.482l-2.743-2.724 7.104-7.055 2.742 2.724a.7.7 0 0 0 .485.2h1.353l-1.783 4.365a2.82 2.82 0 0 0 1.465 3.662 2.87 2.87 0 0 0 3.414-.817l2.237-2.789a.254.254 0 0 1 .377-.02l5.096 5.087 2.565 2.549c.52.514.52 1.353 0 1.87zm.05-7.05a.68.68 0 0 0-.199.421l-.225 2.461-1.22-1.211-5.094-5.088a1.632 1.632 0 0 0-2.424.132l-2.238 2.79a1.49 1.49 0 0 1-1.774.425 1.467 1.467 0 0 1-.761-1.906l1.994-4.88h4.352a.7.7 0 0 0 .485-.2l2.743-2.724 7.103 7.056zm8.394-4.477-1.954 1.94c-.433.43-1.137.43-1.569 0l-9.42-9.357a1.09 1.09 0 0 1-.326-.779c0-.294.115-.57.325-.779l1.954-1.94c.217-.216.5-.323.784-.323s.568.107.785.323l9.42 9.357c.21.207.326.484.326.779 0 .294-.115.57-.325.779"/></mask><path stroke="#000" stroke-width="2" d="M41.82 10.078 32.397.72a2.496 2.496 0 0 0-3.51 0l-1.954 1.941a2.44 2.44 0 0 0-.727 1.743c0 .658.259 1.278.727 1.743l.188.187-2.541 2.524h-6.617l-2.542-2.523.188-.187a2.44 2.44 0 0 0 .727-1.743 2.44 2.44 0 0 0-.727-1.743L13.656.722a2.497 2.497 0 0 0-3.51 0l-9.42 9.356A2.44 2.44 0 0 0 0 11.821c0 .66.258 1.278.727 1.743l1.954 1.941c.484.48 1.12.72 1.755.72.636 0 1.271-.24 1.755-.72l.188-.187 2.541 2.525v2.26L7.86 21.25a1.84 1.84 0 0 0 .083 2.57l9.98 9.49c.347.33.799.51 1.278.51h.06a1.84 1.84 0 0 0 1.303-.593l.167-.18q.19-.207.331-.443.029.002.056.004a2.69 2.69 0 0 0 2.613-2.002c.465.35 1.029.541 1.624.541.722 0 1.4-.28 1.911-.786a2.66 2.66 0 0 0 .726-1.333 2.7 2.7 0 0 0 1.234.297c.722 0 1.401-.28 1.912-.787.73-.725.942-1.761.657-2.679a2.7 2.7 0 0 0 1.582-.764c.51-.508.791-1.182.791-1.9 0-.716-.28-1.39-.791-1.898l-.08-.08.305-3.347 2.566-2.55.188.187c.484.48 1.12.72 1.755.72.636 0 1.271-.24 1.755-.72l1.954-1.94a2.44 2.44 0 0 0 .726-1.744c0-.659-.258-1.277-.726-1.743zM5.22 14.54c-.433.43-1.137.43-1.57 0L1.698 12.6a1.094 1.094 0 0 1 0-1.558l9.42-9.358a1.116 1.116 0 0 1 1.57 0l1.953 1.941c.21.209.325.485.325.78 0 .294-.115.57-.325.778zm3.672 8.292a.474.474 0 0 1-.022-.663l1.663-1.797a1.38 1.38 0 0 1 1.011-.443 1.313 1.313 0 0 1 .97 2.21l-2.037 2.203zm2.577 2.451 2.643-2.857a1.34 1.34 0 0 1 1.881-.079 1.313 1.313 0 0 1 .08 1.869l-2.68 2.897zm2.915 2.772 1.726-1.866a1.34 1.34 0 0 1 1.88-.078 1.313 1.313 0 0 1 .08 1.869l-1.762 1.905zm5.334 4.066-.166.18a.47.47 0 0 1-.336.152.47.47 0 0 1-.345-.131L17.3 30.827l.44-.475c.506-.546 1.356-.593 1.896-.103.264.239.418.566.433.921.015.353-.11.69-.35.951Zm12.687-7.995c-.504.5-1.38.5-1.883 0l-2.032-2.018a.69.69 0 0 0-.97 0 .68.68 0 0 0 0 .964l2.645 2.628c.52.516.52 1.354 0 1.87-.503.5-1.38.5-1.883 0l-3.043-3.022a.69.69 0 0 0-.971 0 .68.68 0 0 0 0 .964l2.024 2.01c.52.516.52 1.355 0 1.87-.503.5-1.38.5-1.883 0l-2.324-2.308a.69.69 0 0 0-.97 0 .68.68 0 0 0 0 .964l.942.936c.25.25.388.58.388.933a1.31 1.31 0 0 1-1.01 1.278q.002-.041 0-.083a2.66 2.66 0 0 0-.88-1.871 2.65 2.65 0 0 0-1.251-.624 2.65 2.65 0 0 0 .484-1.646 2.66 2.66 0 0 0-.873-1.864 2.7 2.7 0 0 0-1.371-.663 2.66 2.66 0 0 0 .246-1.238 2.66 2.66 0 0 0-.873-1.863 2.71 2.71 0 0 0-2.724-.543 2.66 2.66 0 0 0-.84-1.538c-.854-.775-2.082-.888-3.065-.385V17.56a.68.68 0 0 0-.201-.482l-2.743-2.724 7.104-7.055 2.742 2.724a.7.7 0 0 0 .485.2h1.353l-1.783 4.365a2.82 2.82 0 0 0 1.465 3.662 2.87 2.87 0 0 0 3.414-.817l2.237-2.789a.254.254 0 0 1 .377-.02l5.096 5.087 2.565 2.549c.52.514.52 1.353 0 1.87zm.05-7.05a.68.68 0 0 0-.199.421l-.225 2.461-1.22-1.211-5.094-5.088a1.632 1.632 0 0 0-2.424.132l-2.238 2.79a1.49 1.49 0 0 1-1.774.425 1.467 1.467 0 0 1-.761-1.906l1.994-4.88h4.352a.7.7 0 0 0 .485-.2l2.743-2.724 7.103 7.056zm8.394-4.477-1.954 1.94c-.433.43-1.137.43-1.569 0l-9.42-9.357a1.09 1.09 0 0 1-.326-.779c0-.294.115-.57.325-.779l1.954-1.94c.217-.216.5-.323.784-.323s.568.107.785.323l9.42 9.357c.21.207.326.484.326.779 0 .294-.115.57-.325.779Z" mask="url(#b)"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h42.545v33.818H0z"/></clipPath></defs></svg>
            </div>
            <div class="trade-in__card-item-title applecare-item-title">
              <p class="trade-in__card-title apple-care-card-title apl-section-cart-trade-in-title">
                ${item.title}
              </p>
              <p class="trade-in__card-information apl-section-cart-trade-in-description">
                Inbytespris: <strong>${formattedPrice} SEK</strong>
              </p>
              <p class="trade-in__card-co2-info">
                Ditt inbyte minskar ordens totala koldioxidavtryck med ${item.co2Emission} kg
              </p>
              
              <div class="trade-in-remove-btn-container">
              <span>1 x</span>
                    <span class="trade-in-remove-btn" onclick="event.preventDefault(); removeTradeInItem('${item.id}', ${index})">
                      <span>${removeBtnText}</span>
                    </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

  return html;
}

// ------- Due diligence check (tillfälligt avaktiverad) -------
// Original funktion är utkommenterad nedan och ska implementeras vid ett senare tillfälle.
// Under tiden returnerar vi alltid true för att hoppa över kontrollen.
async function performDueDiligenceCheck(modelId, itemIdentifier) {
  return true;
}

/*
async function performDueDiligenceCheck(modelId, itemIdentifier) {
  if (!modelId || !itemIdentifier) {
    return false;
  }

  console.log("performDueDiligenceCheck modelId:", modelId);
  console.log("performDueDiligenceCheck itemIdentifier:", itemIdentifier);

  try {
    const payload = {
      ModelId: modelId,
      ItemIdentifier: itemIdentifier,
    };

    const checkResponse = await postRework(
      "retail/duediligence/check",
      payload
    );

    if (!checkResponse) {
      return false;
    }

    // Hämta rapport
    const report = await fetchRework(
      `retail/duediligence/report/${checkResponse}`
    );

    console.log("performDueDiligenceCheck report:", report);

    if (report && report.FraudCheckResults && report.FraudCheckResults[0]) {
      const result = report.FraudCheckResults[0].Result === "Passed";
      return result;
    }

    return false;
  } catch (error) {
    console.error("❌ DUE DILIGENCE - Error:", error);
    return false;
  }
}
*/

// ------- CO2 Emission fetch -------
async function fetchCo2Emission(priceQuoteId) {
  if (!priceQuoteId) return null;

  try {
    const response = await fetchRework(
      `retail/price-quote/${priceQuoteId}/co2-emission`
    );
    return response?.Value || 0;
  } catch (error) {
    console.error("Error fetching CO2 emission:", error);
    return 0;
  }
}

// ------- Global Trade-in Functions -------
// These functions are called from HTML onclick handlers and need to be globally accessible

// Global variables to store DOM elements and state
let globalTradeInState = {
  input: null,
  hidden: null,
  combo: null,
  savedTradeins: [],
  userInputValue: null, // Sparar värdet användaren skrev innan dropdown-val
};

// Initialize global state when DOM is loaded
function initializeGlobalTradeInState() {
  globalTradeInState.input = document.querySelector("#tradein-input");
  globalTradeInState.hidden = document.querySelector("#foxway_model_id");
  globalTradeInState.combo = document.querySelector(".tradein-combobox");
}

async function updateGradingValueWithButton(questionIndex, isChecked) {
  const modelId = globalTradeInState.hidden?.value;
  if (!modelId) return;

  try {
    const currentAnswers = JSON.parse(
      globalTradeInState.input?.dataset.answers || "{}"
    );
    currentAnswers[questionIndex] = [!isChecked ? 1 : 0];
    globalTradeInState.input.dataset.answers = JSON.stringify(currentAnswers);

    // Uppdatera UI för knapparna
    const yesBtn = document.getElementById(`check-yes-btn-${questionIndex}`);
    const noBtn = document.getElementById(`check-no-btn-${questionIndex}`);
    const activeElement = document.getElementById(
      `tradein-check-btn-active-${questionIndex}`
    );

    if (isChecked) {
      yesBtn.style.color = "#3f3c39";
      noBtn.style.color = "#e5e5e5";
      if (activeElement.classList.contains("tradein-check-btn-active-right")) {
        activeElement.classList.remove("tradein-check-btn-active-right");
      }
    } else {
      yesBtn.style.color = "#e5e5e5";
      noBtn.style.color = "#3f3c39";
      if (!activeElement.classList.contains("tradein-check-btn-active-right")) {
        activeElement.classList.add("tradein-check-btn-active-right");
      }
    }

    const payload = {
      GradingForm: {
        Answers: currentAnswers,
      },
      ModelId: modelId,
    };

    let priceQuote = await postRework("retail/price-quote", payload);

    if (priceQuote) {
      globalTradeInState.input.dataset.priceQuote = JSON.stringify(priceQuote);
      globalTradeInState.input.dataset.offeredPrice =
        priceQuote.OfferedPrice || 0;
      // Uppdatera UI med nytt pris
      updatePriceDisplay(priceQuote.OfferedPrice);
    }
  } catch (error) {
    console.error("Error updating grading value:", error);
  }
}

async function setAllGood(checked) {
  const modelId = globalTradeInState.hidden?.value;
  if (!modelId) return;

  try {
    const currentAnswers = JSON.parse(
      globalTradeInState.input?.dataset.answers || "{}"
    );
    Object.keys(currentAnswers).forEach((key) => {
      currentAnswers[key] = [0]; // Allt är bra
    });
    globalTradeInState.input.dataset.answers = JSON.stringify(currentAnswers);

    if (checked) {
      const tradeinQuestions = document.querySelectorAll(".tradein-question");
      tradeinQuestions.forEach((element) => {
        if (
          !element.classList.contains("tradein-grading-form-question-hidden")
        ) {
          element.classList.add("tradein-grading-form-question-hidden");
        }
      });
      document.getElementById("check-yes-btn").style.color = "#3f3c39";
      document.getElementById("check-no-btn").style.color = "#ffffff";

      const activeElement = document.getElementById("tradein-check-btn-active");
      if (activeElement.classList.contains("tradein-check-btn-active-right")) {
        activeElement.classList.remove("tradein-check-btn-active-right");
      }
    } else {
      const tradeinQuestions = document.querySelectorAll(".tradein-question");
      tradeinQuestions.forEach((element) => {
        if (
          element.classList.contains("tradein-grading-form-question-hidden")
        ) {
          element.classList.remove("tradein-grading-form-question-hidden");
        }
      });
      document.getElementById("check-yes-btn").style.color = "#ffffff";
      document.getElementById("check-no-btn").style.color = "#3f3c39";

      const activeElement = document.getElementById("tradein-check-btn-active");
      if (!activeElement.classList.contains("tradein-check-btn-active-right")) {
        activeElement.classList.add("tradein-check-btn-active-right");
      }
    }

    const payload = {
      GradingForm: {
        Answers: currentAnswers,
      },
      ModelId: modelId,
    };

    let priceQuote = await postRework("retail/price-quote", payload);

    if (priceQuote) {
      globalTradeInState.input.dataset.priceQuote = JSON.stringify(priceQuote);
      globalTradeInState.input.dataset.offeredPrice =
        priceQuote.OfferedPrice || 0;
      updatePriceDisplay(priceQuote.OfferedPrice);
    }
  } catch (error) {
    console.error("Error setting all good:", error);
  }
}

async function addTradein() {
  // Hämta det sparade värdet som användaren skrev innan dropdown-val
  const userInputValue = globalTradeInState.userInputValue || "";

  // Samla all data från input
  const tradeinData = {
    id: Date.now(), // Always create new ID for new trade-ins
    modelId: globalTradeInState.hidden?.value,
    productName:
      globalTradeInState.input?.dataset.productName ||
      globalTradeInState.input?.value,
    offeredPrice:
      parseFloat(globalTradeInState.input?.dataset.offeredPrice) || 0,
    co2Emission: parseFloat(globalTradeInState.input?.dataset.co2Emission) || 0,
    gradingForm: globalTradeInState.input?.dataset.gradingForm,
    answers: globalTradeInState.input?.dataset.answers,
    priceQuote: globalTradeInState.input?.dataset.priceQuote,
    userInputValue: userInputValue, // Det värde användaren skrev innan dropdown-val
  };

  // Utför due diligence check innan trade-in läggs till (tillfälligt hoppad över)
  // try {
  //   const dueDiligencePassed = await performDueDiligenceCheck(globalTradeInState.hidden?.value, globalTradeInState.input?.value);
  //
  //   if (!dueDiligencePassed) {
  //     console.error(
  //       "❌ DUE DILIGENCE MISSLYCKADES - Trade-in kan inte läggas till"
  //     );
  //     alert(
  //       "Enhetsverifiering misslyckades. Kontrollera att enheten inte är stulen eller har iCloud-lås."
  //     );
  //     return;
  //   }
  // } catch (error) {
  //   console.error("❌ FEL VID DUE DILIGENCE CHECK:", error);
  //   alert("Ett fel uppstod vid enhetsverifiering. Försök igen.");
  //   return;
  // }

  // Lägg till ny instans
  globalTradeInState.savedTradeins.push(tradeinData);
  // Visa ny trade-in instans
  displayTradeinInstance(tradeinData);

  // Stäng dropdown och reset form
  closeTradeinDropdown();
  resetTradeinForm();

  // Uppdatera total värde
  updateTotalTradeinValue();
}

function removeTradeinInstance(tradeinId) {
  // Ta bort från array
  globalTradeInState.savedTradeins = globalTradeInState.savedTradeins.filter(
    (t) => t.id !== tradeinId
  );

  // Ta bort från DOM
  const instanceElement = document.querySelector(
    `[data-tradein-id="${tradeinId}"]`
  );
  if (instanceElement) {
    instanceElement.remove();
  }

  // Uppdatera total värde
  updateTotalTradeinValue();
}

async function updateGradingValueForInstance(
  tradeinId,
  questionIndex,
  isChecked
) {
  const tradeinData = globalTradeInState.savedTradeins.find(
    (t) => t.id === tradeinId
  );
  if (!tradeinData) return;

  try {
    const currentAnswers = JSON.parse(tradeinData.answers || "{}");
    currentAnswers[questionIndex] = [isChecked ? 1 : 0];
    tradeinData.answers = JSON.stringify(currentAnswers);

    // Uppdatera UI för denna fråga
    const instanceElement = document.querySelector(
      `[data-tradein-id="${tradeinId}"]`
    );
    if (instanceElement) {
      const yesBtn = document.getElementById(
        `check-yes-btn-${tradeinId}-${questionIndex}`
      );
      const noBtn = document.getElementById(
        `check-no-btn-${tradeinId}-${questionIndex}`
      );
      const activeElement = document.getElementById(
        `tradein-check-btn-active-${tradeinId}-${questionIndex}`
      );

      if (isChecked) {
        yesBtn.style.color = "#3f3c39";
        noBtn.style.color = "#e5e5e5";
        if (
          activeElement.classList.contains("tradein-check-btn-active-right")
        ) {
          activeElement.classList.remove("tradein-check-btn-active-right");
        }
      } else {
        yesBtn.style.color = "#e5e5e5";
        noBtn.style.color = "#3f3c39";
        if (
          !activeElement.classList.contains("tradein-check-btn-active-right")
        ) {
          activeElement.classList.add("tradein-check-btn-active-right");
        }
      }
    }

    const payload = {
      GradingForm: {
        Answers: currentAnswers,
      },
      ModelId: tradeinData.modelId,
    };

    let priceQuote = await postRework("retail/price-quote", payload);

    if (priceQuote) {
      const oldPrice = tradeinData.offeredPrice;
      tradeinData.priceQuote = JSON.stringify(priceQuote);
      tradeinData.offeredPrice = priceQuote.OfferedPrice || 0;

      // Uppdatera instansens värde i UI
      updateInstanceValueDisplay(tradeinId, tradeinData.offeredPrice);
      updateTotalTradeinValue();
    }
  } catch (error) {
    console.error("Error updating grading value for instance:", error);
  }
}

async function setAllGoodForInstance(tradeinId, checked) {
  const tradeinData = globalTradeInState.savedTradeins.find(
    (t) => t.id === tradeinId
  );
  if (!tradeinData) return;

  try {
    const currentAnswers = JSON.parse(tradeinData.answers || "{}");
    Object.keys(currentAnswers).forEach((key) => {
      currentAnswers[key] = [0]; // Allt är bra
    });
    tradeinData.answers = JSON.stringify(currentAnswers);

    // Uppdatera UI för denna instans
    const instanceElement = document.querySelector(
      `[data-tradein-id="${tradeinId}"]`
    );
    if (instanceElement) {
      const tradeinQuestions =
        instanceElement.querySelectorAll(".tradein-question");
      tradeinQuestions.forEach((element) => {
        if (checked) {
          element.classList.add("tradein-grading-form-question-hidden");
        } else {
          element.classList.remove("tradein-grading-form-question-hidden");
        }
      });

      // Uppdatera knappar
      const yesBtn = document.getElementById(`check-yes-btn-${tradeinId}`);
      const noBtn = document.getElementById(`check-no-btn-${tradeinId}`);
      const activeElement = document.getElementById(
        `tradein-check-btn-active-${tradeinId}`
      );

      if (checked) {
        yesBtn.style.color = "#3f3c39";
        noBtn.style.color = "#ffffff";
        if (
          activeElement.classList.contains("tradein-check-btn-active-right")
        ) {
          activeElement.classList.remove("tradein-check-btn-active-right");
        }
      } else {
        yesBtn.style.color = "#ffffff";
        noBtn.style.color = "#3f3c39";
        if (
          !activeElement.classList.contains("tradein-check-btn-active-right")
        ) {
          activeElement.classList.add("tradein-check-btn-active-right");
        }
      }
    }

    const payload = {
      GradingForm: {
        Answers: currentAnswers,
      },
      ModelId: tradeinData.modelId,
    };

    let priceQuote = await postRework("retail/price-quote", payload);

    if (priceQuote) {
      const oldPrice = tradeinData.offeredPrice;
      tradeinData.priceQuote = JSON.stringify(priceQuote);
      tradeinData.offeredPrice = priceQuote.OfferedPrice || 0;

      // Uppdatera instansens värde i UI
      updateInstanceValueDisplay(tradeinId, tradeinData.offeredPrice);
      updateTotalTradeinValue();
    }
  } catch (error) {
    console.error("Error setting all good for instance:", error);
  }
}

function toggleTradeinDropdown() {
  const wrapper = document.getElementById("tradein-instances-wrapper");
  if (!wrapper) return;

  // Kontrollera om tradein-instances-container är tom
  const container = document.getElementById("tradein-instances-container");
  if (!container || container.children.length === 0) {
    return;
  }

  const isOpen = wrapper.getAttribute("data-dropdown-open") === "true";

  if (isOpen) {
    // Stäng dropdown
    wrapper.setAttribute("data-dropdown-open", "false");
    wrapper.classList.remove("tradein-dropdown-open");

    // Uppdatera chevron
    const chevron = wrapper.querySelector(".chevron");
    if (chevron) {
      chevron.textContent = "▼";
    }
  } else {
    // Öppna dropdown
    wrapper.setAttribute("data-dropdown-open", "true");
    wrapper.classList.add("tradein-dropdown-open");

    // Uppdatera chevron
    const chevron = wrapper.querySelector(".chevron");
    if (chevron) {
      chevron.textContent = "▲";
    }
  }
}

// ------- Remove Trade-In Item Function -------
async function removeTradeInItem(itemId, itemIndex) {
  try {
    // Find the wrapper that contains this trade-in item
    const tradeInWrappers = document.querySelectorAll(
      "[data-trade-in-item-json]"
    );
    let targetWrapper = null;
    let targetItemData = null;

    // Find the wrapper that contains the item with this ID
    for (const wrapper of tradeInWrappers) {
      const tradeInDataJson = wrapper.getAttribute("data-trade-in-item-json");
      if (tradeInDataJson) {
        const tradeInData = JSON.parse(tradeInDataJson);
        if (
          tradeInData.macforum_trade_items &&
          tradeInData.macforum_trade_items.items
        ) {
          const itemExists = tradeInData.macforum_trade_items.items.some(
            (item) => item.id === itemId
          );
          if (itemExists) {
            targetWrapper = wrapper;
            targetItemData = tradeInData;
            break;
          }
        }
      }
    }

    if (!targetWrapper || !targetItemData) {
      console.error(
        "❌ Could not find wrapper or data for trade-in item:",
        itemId
      );
      return;
    }

    // Remove the item from the items array
    const originalItems = targetItemData.macforum_trade_items.items;
    const updatedItems = originalItems.filter((item) => item.id !== itemId);

    // If no items remain, set trade-in data to null
    let updatedTradeInData = null;
    if (updatedItems.length > 0) {
      // Recalculate total
      const newTotal = updatedItems.reduce(
        (sum, item) => sum + item.offeredPrice,
        0
      );

      // Update the data structure only if there are items remaining
      updatedTradeInData = {
        ...targetItemData,
        macforum_trade_items: {
          ...targetItemData.macforum_trade_items,
          items: updatedItems,
          total: newTotal,
        },
      };
    }

    // Extract cart item key from wrapper ID or cart data
    let cartItemKey = null;

    // Try to get cart item key from wrapper ID first
    const wrapperId = targetWrapper.getAttribute("id");
    if (wrapperId && wrapperId.startsWith("CartItem-trade-in-")) {
      const index = wrapperId.replace("CartItem-trade-in-", "");
      const cartItemRow = document.getElementById(`CartItem-${index}`);
      if (cartItemRow) {
        // Try to find cart item by fetching cart and matching index
        try {
          const cartResponse = await fetch("/cart.js");
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const cartItemIndex = parseInt(index) - 1;
            if (cart.items[cartItemIndex]) {
              cartItemKey = cart.items[cartItemIndex].key;
            }
          }
        } catch (error) {
          console.error("Error fetching cart for cart item key:", error);
        }
      }
    }

    // If still not found, try to find by trade-in data
    if (!cartItemKey) {
      try {
        const cartResponse = await fetch("/cart.js");
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          // Find cart item that has this trade-in data
          for (const item of cart.items) {
            if (item.properties && item.properties._trade_in_data) {
              try {
                const existingData = JSON.parse(item.properties._trade_in_data);
                if (
                  existingData.macforum_trade_items &&
                  existingData.macforum_trade_items.items &&
                  existingData.macforum_trade_items.items.some(
                    (ti) => ti.id === itemId
                  )
                ) {
                  cartItemKey = item.key;
                  break;
                }
              } catch (e) {
                // Skip items with invalid JSON
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching cart for cart item key:", error);
      }
    }

    // Update the cart via Shopify API
    await updateCartWithTradeInData(
      targetWrapper,
      updatedTradeInData,
      cartItemKey
    );

    // Update the wrapper's data attribute with new data
    if (updatedTradeInData === null) {
      targetWrapper.removeAttribute("data-trade-in-item-json");
      // Clear the trade-in items display when all items are removed
      const targetTd = targetWrapper.querySelector(
        `[id^="trade-inline-item-"]`
      );
      if (targetTd) {
        targetTd.innerHTML = "";
      }
      // Reload the page to re-render grebban-trade-in-cart.liquid
      // This is necessary because Liquid rendering happens on the server
      // and we need the cart section to re-render with the updated condition
      window.location.reload();
      return;
    } else {
      targetWrapper.setAttribute(
        "data-trade-in-item-json",
        JSON.stringify(updatedTradeInData)
      );
      // Re-render the trade-in items
      parseAndRenderTradeInItems();
    }

    // Update cart price displays
    updateCartPriceDisplays();
  } catch (error) {
    console.error("❌ Error removing trade-in item:", error);
    alert("Ett fel uppstod vid borttagning av trade-in objekt. Försök igen.");
  }
}

// ------- Helper Functions for Global Trade-in Functions -------
function updatePriceDisplay(price) {
  // Hitta eller skapa element för prisvisning
  let priceElement = document.querySelector(".tradein-price-display");
  if (!priceElement) {
    priceElement = document.createElement("div");
    priceElement.className = "tradein-price-display";
    globalTradeInState.combo?.appendChild(priceElement);
  }
  priceElement.innerHTML = `<div class="tradein-price-text"><span>Uppskattat inbytesvärde:</span> <strong>${formatSwedishNumber(
    price
  )} SEK*</strong></div>`;
  priceElement.innerHTML += `
    <div class="tradein-price-disclaimer">
      * Observera att värderingen som utförs på denna sida ger ett uppskattat inbytesvärde. Det slutgiltiga värdet avgörs samt krediteras din valda betalmetod när vi tagit emot din inbytesenhet och bekräftat enhetens skick.
    </div>
  `;
}

function displayTradeinInstance(tradeinData) {
  // Skapa wrapper för trade-in instanser om den inte finns
  let instancesWrapper = document.getElementById("tradein-instances-wrapper");
  if (!instancesWrapper) {
    instancesWrapper = document.createElement("div");
    instancesWrapper.id = "tradein-instances-wrapper";
    instancesWrapper.className = "tradein-instances-wrapper";

    // Infoga efter combobox
    globalTradeInState.combo?.parentNode?.insertBefore(
      instancesWrapper,
      globalTradeInState.combo?.nextSibling
    );

    // Lägg till header med total värde
    addTotalValueHeader(instancesWrapper);
  }

  // Skapa container för trade-in instanser om den inte finns
  let instancesContainer = document.getElementById(
    "tradein-instances-container"
  );
  if (!instancesContainer) {
    instancesContainer = document.createElement("div");
    instancesContainer.id = "tradein-instances-container";
    instancesContainer.className = "tradein-instances-container";

    // Lägg till i wrapper
    instancesWrapper.appendChild(instancesContainer);
  }

  // Skapa trade-in instans
  const instanceDiv = document.createElement("div");
  instanceDiv.className = "tradein-instance";
  instanceDiv.dataset.tradeinId = tradeinData.id;

  // Skapa grading form HTML om den finns
  let gradingFormHTML = "";
  if (tradeinData.gradingForm) {
    try {
      const grading = JSON.parse(tradeinData.gradingForm);
      const answers = JSON.parse(tradeinData.answers || "{}");

      gradingFormHTML = `
          <div class="tradein-instance-grading">
            <div class="tradein-all-good">
              <div class="tradein-all-good-title">
                <span>Är enheten i gott skick?</span>
                <span>Svara ja om alla dessa påståenden stämmer:</span>
              </div>
              <ul>
                <li>Enheten startar upp och fortsätter utan laddare</li>
                <li>Enheten är komplett, inga delar saknas, knappar finns och är fungerande</li>
                <li>Skärmen är fullt fungerande och i perfekt skick. Ingen beläggning, inga repor eller pixeldefekter</li>
                <li>Det finns inga sprickor, eller skador på skärmen, ramen eller bakstycket</li>
                <li>Inga obehöriga delar eller modifieringar har använts</li>
              </ul>
              <div class="tradein-check-btn-wrapper">
                <div id="tradein-check-btn-active-${tradeinData.id}" class="tradein-check-btn-active"></div>
                <div style="color:#3f3c39" id="check-yes-btn-${tradeinData.id}" class="tradein-check-btn-default" onclick="setAllGoodForInstance(${tradeinData.id}, true)">
                  <span>Ja</span>
                </div>
                <div id="check-no-btn-${tradeinData.id}" class="tradein-check-btn-default" onclick="setAllGoodForInstance(${tradeinData.id}, false)">
                  <span>Nej</span>
                </div>
              </div>
            </div>
        `;

      // Lägg till individuella frågor
      if (grading.Questions && grading.Questions.length > 0) {
        grading.Questions.forEach((question, index) => {
          const isChecked = answers[index] && answers[index][0] === 1;
          gradingFormHTML += `
              <div class="tradein-question tradein-grading-form-question-hidden">
                <h4>${question.Name}</h4>
                ${
                  question.InfoCards
                    ? question.InfoCards.map(
                        (card) =>
                          `<div class="tradein-info-card">${card.Text}</div>`
                      ).join("")
                    : ""
                }
                <div class="tradein-check-btn-wrapper">
                  <div id="tradein-check-btn-active-${
                    tradeinData.id
                  }-${index}" class="tradein-check-btn-active ${
            isChecked ? "" : "tradein-check-btn-active-right"
          }"></div>
                  <div style="color:${
                    isChecked ? "#3f3c39" : "#e5e5e5"
                  }" id="check-yes-btn-${
            tradeinData.id
          }-${index}" class="tradein-check-btn-default" onclick="updateGradingValueForInstance(${
            tradeinData.id
          }, ${index}, true)">
                    <span>Ja</span>
                  </div>
                  <div id="check-no-btn-${
                    tradeinData.id
                  }-${index}" class="tradein-check-btn-default" onclick="updateGradingValueForInstance(${
            tradeinData.id
          }, ${index}, false)" style="color:${
            isChecked ? "#e5e5e5" : "#3f3c39"
          }">
                    <span>Nej</span>
                  </div>
                </div>
              </div>
            `;
        });
      }

      gradingFormHTML += "</div>";
    } catch (error) {
      console.error("Error parsing grading form for instance:", error);
    }
  }

  // Lägg till värde-display efter grading form
  const valueDisplayHTML = `
      <div class="tradein-instance-value-display" id="tradein-instance-value-${
        tradeinData.id
      }">
        <div class="tradein-instance-value-text">
          <span>Uppskattat inbytesvärde:</span> <strong>${formatSwedishNumber(
            tradeinData.offeredPrice
          )} SEK*</strong>
        </div>
        <div class="tradein-instance-value-disclaimer">
          * Observera att värderingen som utförs på denna sida ger ett uppskattat inbytesvärde. Det slutgiltiga värdet avgörs samt krediteras din valda betalmetod när vi tagit emot din inbytesenhet och bekräftat enhetens skick.
        </div>
      </div>
    `;

  instanceDiv.innerHTML = `
      <div class="tradein-instance-content">
        <div class="tradein-instance-header">
          <h4> ${tradeinData.productName}</h4>
          <span class="tradein-remove-instance-btn" onclick="removeTradeinInstance(${tradeinData.id})">x</span>
        </div>
        ${gradingFormHTML}
        ${valueDisplayHTML}
      </div>
    `;

  instancesContainer.appendChild(instanceDiv);
}

function updateInstanceValueDisplay(tradeinId, newValue) {
  const instanceElement = document.querySelector(
    `[data-tradein-id="${tradeinId}"]`
  );
  if (instanceElement) {
    const valueDisplayElement = document.getElementById(
      `tradein-instance-value-${tradeinId}`
    );
    if (valueDisplayElement) {
      const valueTextElement = valueDisplayElement.querySelector(
        ".tradein-instance-value-text"
      );
      if (valueTextElement) {
        valueTextElement.innerHTML = `<span>Uppskattat inbytesvärde:</span> <strong>${formatSwedishNumber(
          newValue
        )} SEK*</strong>`;
      }
    }
  }
}

function updateTotalTradeinValue() {
  const totalValue = globalTradeInState.savedTradeins.reduce(
    (sum, tradein) => sum + tradein.offeredPrice,
    0
  );
  const totalCo2 = globalTradeInState.savedTradeins.reduce(
    (sum, tradein) => sum + tradein.co2Emission,
    0
  );

  // Uppdatera header-värdet
  const totalAmountElement = document.getElementById("tradein-total-amount");
  if (totalAmountElement) {
    totalAmountElement.textContent = formatSwedishNumber(totalValue);
  }

  // Uppdatera CO2-värdet
  const totalCo2Element = document.getElementById("tradein-total-co2-amount");
  if (totalCo2Element) {
    totalCo2Element.textContent = totalCo2;
  }

  const totalHeaderElement = document.getElementById("tradein-total-header");
  if (totalHeaderElement) {
    if (totalValue === 0) {
      totalHeaderElement.style.display = "none";
    } else {
      totalHeaderElement.style.display = "block";
    }
  }

  // Uppdatera price__container element
  updatePriceContainers(totalValue);
}

function updatePriceContainers(totalValue) {
  // Hitta alla element med klassen price__container eller cto-header__price
  const priceContainers = document.querySelectorAll(
    ".price__container, .cto-header__price"
  );

  priceContainers.forEach((container) => {
    // Lägg till klassen price__container_tradein
    container.classList.add("price__container_tradein");

    // Ta bort befintlig trade-in span om den finns
    const existingSpan = container.querySelector(".tradein-total-value-span");
    if (existingSpan) {
      existingSpan.remove();
    }

    // Hämta pris från tradein-accordion-wrapper data-product-original-price
    const tradeinWrapper = document.getElementById("tradein-accordion-wrapper");
    let finalPrice = 0;

    if (tradeinWrapper) {
      const originalPriceText = tradeinWrapper.getAttribute(
        "data-product-original-price"
      );
      if (originalPriceText) {
        // Extrahera nummer från text (ta bort "kr" och andra tecken)
        const priceMatch = originalPriceText.match(/[\d\s]+/);
        if (priceMatch) {
          const originalPrice = parseInt(priceMatch[0].replace(/\s/g, "")) || 0;
          finalPrice = Math.max(0, originalPrice - totalValue);
        }
      }
    }

    // Lägg till ny span med slutpris endast om trade-in value > 0
    if (totalValue > 0) {
      const tradeinSpan = document.createElement("span");
      tradeinSpan.className = "tradein-total-value-span";
      tradeinSpan.textContent = `${formatSwedishNumber(
        finalPrice
      )} SEK vid mottaget och godkänt inbyte`;

      container.appendChild(tradeinSpan);
    }
  });
}

// ------- Update Cart Price Displays -------
async function updateCartPriceDisplays() {
  // Hämta cart data för att få total_price
  const cart = await fetch("/cart.js").then((r) => r.json());

  // Hitta alla trade-in wrappers för att beräkna totalt värde
  const tradeInWrappers = document.querySelectorAll(
    "[data-trade-in-item-json]"
  );
  let totalTradeInValue = 0;

  // Beräkna totalt trade-in värde från alla wrappers
  tradeInWrappers.forEach((wrapper) => {
    const tradeInDataJson = wrapper.getAttribute("data-trade-in-item-json");
    if (tradeInDataJson) {
      try {
        const tradeInData = JSON.parse(tradeInDataJson);
        if (
          tradeInData.macforum_trade_items &&
          tradeInData.macforum_trade_items.total
        ) {
          totalTradeInValue += tradeInData.macforum_trade_items.total;
        }
      } catch (error) {
        console.error("Error parsing trade-in data for price display:", error);
      }
    }
  });

  // Uppdatera cart-item__price-wrapper (per line item - använder individuell uträkning)
  updateCartItemPriceWrapper();

  // Uppdatera totals--has-nmp (hela cart - använder cart.total_price - totalTradeInValue)
  updateTotalsPriceWrapper(cart.total_price, totalTradeInValue);
}

function updateCartItemPriceWrapper() {
  const priceWrappers = document.querySelectorAll(
    ".cart-item__price-wrapper.apl-section-product-price"
  );

  priceWrappers.forEach((wrapper) => {
    // Ta bort befintlig trade-in span om den finns
    const existingSpan = wrapper.querySelector(
      ".cart-tradein-total-value-span"
    );
    if (existingSpan) {
      existingSpan.remove();
    }

    // Hitta den associerade cart item row för denna price wrapper
    const cartItemRow = wrapper.closest("tr, .cart-item");
    if (!cartItemRow) return;

    // Hitta cart item ID (t.ex. "CartItem-1")
    const cartItemId = cartItemRow.id;
    if (!cartItemId || !cartItemId.startsWith("CartItem-")) return;

    // Extrahera index från cart item ID (t.ex. "1" från "CartItem-1")
    const cartItemIndex = cartItemId.replace("CartItem-", "");

    // Hitta motsvarande trade-in wrapper (t.ex. "CartItem-trade-in-1")
    const tradeInWrapperId = `CartItem-trade-in-${cartItemIndex}`;
    const tradeInWrapper = document.getElementById(tradeInWrapperId);

    if (!tradeInWrapper) return;

    // Hämta trade-in data för denna specifika line item
    let lineItemTradeInValue = 0;
    const tradeInDataJson = tradeInWrapper.getAttribute(
      "data-trade-in-item-json"
    );

    if (tradeInDataJson) {
      try {
        const tradeInData = JSON.parse(tradeInDataJson);
        if (
          tradeInData.macforum_trade_items &&
          tradeInData.macforum_trade_items.total
        ) {
          lineItemTradeInValue = tradeInData.macforum_trade_items.total;
        }
      } catch (error) {
        console.error("Error parsing trade-in data for line item:", error);
      }
    }

    // Hitta original_line_price för denna line item
    let originalLinePrice = 0;
    const priceElement = wrapper.querySelector(
      '.price, .cart-item__price, [class*="price"]'
    );
    if (priceElement) {
      const priceText = priceElement.textContent || priceElement.innerText;
      const priceMatch = priceText.match(/[\d\s]+/);
      if (priceMatch) {
        // Priset från DOM är redan i kronor (formaterat), så vi behöver inte konvertera
        originalLinePrice = parseInt(priceMatch[0].replace(/\s/g, "")) || 0;
      }
    }

    // Beräkna slutpris: original_line_price (i kronor) - lineItemTradeInValue (i kronor)
    const finalPrice = Math.max(0, originalLinePrice - lineItemTradeInValue);

    // Lägg till ny span med slutpris endast om trade-in value > 0
    if (lineItemTradeInValue > 0) {
      const tradeinSpan = document.createElement("div");
      tradeinSpan.className = "cart-tradein-total-value-span";
      tradeinSpan.textContent = `${formatSwedishNumber(
        finalPrice
      )} SEK vid mottaget och godkänt inbyte`;

      wrapper.appendChild(tradeinSpan);
    }
  });
}

function updateTotalsPriceWrapper(cartTotalPrice, totalTradeInValue) {
  const totalsWrappers = document.querySelectorAll(
    ".cart__subtotal-wrapper.cart__subtotal-wrapper--has-nmp"
  );

  totalsWrappers.forEach((wrapper) => {
    // Ta bort befintlig trade-in span om den finns
    const existingSpan = wrapper.querySelector(
      ".cart-tradein-total-value-span"
    );
    if (existingSpan) {
      existingSpan.remove();
    }

    // Konvertera cart.total_price från öre till kronor (dela med 100)
    const cartTotalPriceInKronor = cartTotalPrice / 100;

    // Beräkna slutpris: cart.total_price (i kronor) - totalTradeInValue (i kronor)
    const finalPrice = Math.max(0, cartTotalPriceInKronor - totalTradeInValue);

    // Lägg till ny span med slutpris endast om trade-in value > 0
    if (totalTradeInValue > 0) {
      const tradeinSpan = document.createElement("div");
      tradeinSpan.className = "cart-tradein-total-value-span";
      tradeinSpan.textContent = `${formatSwedishNumber(
        finalPrice
      )} SEK vid mottaget och godkänt inbyte`;

      wrapper.appendChild(tradeinSpan);
    }
  });
}

function addTotalValueHeader(wrapper) {
  const headerDiv = document.createElement("div");
  headerDiv.id = "tradein-total-header";
  headerDiv.className = "tradein-total-header";

  const totalValue = globalTradeInState.savedTradeins.reduce(
    (sum, tradein) => sum + tradein.offeredPrice,
    0
  );

  const totalCo2 = globalTradeInState.savedTradeins.reduce(
    (sum, tradein) => sum + tradein.co2Emission,
    0
  );

  headerDiv.innerHTML = `
      <div class="tradein-total-header-content">
        <div class="tradein-total-header-main">
          <span class="tradein-total-text">Du har <span id="tradein-total-amount">${formatSwedishNumber(
            totalValue
          )}</span> SEK i inbytesvärde*</span>
        </div>
        <div class="tradein-total-disclaimer">
          *Observera att värderingen som utförs på denna sida ger ett uppskattat inbytesvärde
        </div>
        <div class="tradein-total-co2">
          Ditt inbyte minskar ordens totala koldioxidavtryck med <span id="tradein-total-co2-amount">${totalCo2}</span> kg
        </div>
      </div>
    `;

  wrapper.appendChild(headerDiv);

  // Lägg till dropdown-funktionalitet
  wrapper.classList.add("tradein-dropdown-wrapper");
  wrapper.setAttribute("data-dropdown-open", "false");

  // Dölj tradein-accordion-button
  const accordionButton = document.getElementById("tradein-accordion-button");
  if (accordionButton) {
    accordionButton.style.display = "none";
  }

  // Skapa ny knapp i .tradein-details
  const tradeinDetails = document.querySelector(".tradein-details");
  if (tradeinDetails) {
    // Ta bort befintlig knapp om den finns
    const existingEditBtn = tradeinDetails.querySelector(
      ".tradein-edit-all-btn"
    );
    if (existingEditBtn) {
      existingEditBtn.remove();
    }

    // Skapa ny knapp
    const editButton = document.createElement("span");
    editButton.className =
      "tradein-edit-all-btn img_with_txt_btn button_primary_clicked_hollow";
    editButton.textContent = "Ändra";
    editButton.onclick = toggleTradeinDropdown;
    tradeinDetails.insertBefore(editButton, tradeinDetails.firstChild);
  }
}

function closeTradeinDropdown() {
  // Stäng accordion
  const accordion = document.querySelector('[id^="Details-"]');
  if (accordion && accordion.hasAttribute("open")) {
    accordion.removeAttribute("open");
  }
}

function resetTradeinForm() {
  // Återställ input fält
  if (globalTradeInState.input) {
    globalTradeInState.input.value = "";
    globalTradeInState.input.readOnly = false;
    globalTradeInState.input.removeAttribute("data-price");
    globalTradeInState.input.removeAttribute("data-productName");
    globalTradeInState.input.removeAttribute("data-gradingForm");
    globalTradeInState.input.removeAttribute("data-answers");
    globalTradeInState.input.removeAttribute("data-priceQuote");
    globalTradeInState.input.removeAttribute("data-offeredPrice");
    globalTradeInState.input.removeAttribute("data-co2Emission");
  }

  // Återställ hidden input
  if (globalTradeInState.hidden) {
    globalTradeInState.hidden.value = "";
  }

  // Dölj grading form
  const gradingForm = document.getElementById("tradein-grading-form");
  if (gradingForm) {
    gradingForm.style.display = "none";
    gradingForm.innerHTML = "";
  }

  // Dölj due diligence
  const dueDiligence = document.getElementById("tradein-due-diligence");
  if (dueDiligence) {
    dueDiligence.style.display = "none";
  }

  // Rensa prisvisning
  const priceDisplay = document.querySelector(".tradein-price-display");
  if (priceDisplay) {
    priceDisplay.remove();
  }

  // Återställ combobox state
  if (globalTradeInState.combo) {
    globalTradeInState.combo.setAttribute("aria-expanded", "false");
    document
      .getElementsByClassName("tradein-combobox")[0]
      ?.classList.remove("trade-in-open-dropdown");
  }
}

function getFormattedTradeInData() {
  if (globalTradeInState.savedTradeins.length === 0) {
    return null;
  }

  const totalValue = globalTradeInState.savedTradeins.reduce(
    (sum, tradein) => sum + tradein.offeredPrice,
    0
  );

  const formattedData = {
    macforum_trade_items: {
      items: globalTradeInState.savedTradeins.map((tradein) => {
        // Parse grading form och answers
        let gradingForm = null;
        let answers = [];

        try {
          gradingForm = JSON.parse(tradein.gradingForm || "{}");
          const parsedAnswers = JSON.parse(tradein.answers || "{}");

          // Kontrollera om "Allt är bra" är valt (alla svar är 0 = Ja)
          const allAnswersAreYes = Object.values(parsedAnswers).every(
            (answer) => answer && answer[0] === 0
          );

          // Konvertera answers till önskat format
          if (gradingForm.Questions && gradingForm.Questions.length > 0) {
            answers = gradingForm.Questions.map((question, index) => {
              const answerValue = parsedAnswers[index]
                ? parsedAnswers[index][0]
                : 0;

              // Om "Allt är bra" är valt, sätt alla svar till "Ja"
              if (allAnswersAreYes) {
                return {
                  question: question.Name,
                  answer: "Ja",
                };
              } else {
                return {
                  question: question.Name,
                  answer: answerValue === 1 ? "Ja" : "Nej",
                };
              }
            });
          }
        } catch (error) {
          console.error("Error parsing trade-in data:", error);
        }

        return {
          id: tradein.id.toString(),
          title: tradein.productName,
          modelId: parseInt(tradein.modelId),
          answers: answers,
          offeredPrice: Math.round(tradein.offeredPrice),
          PriceQuoteId: tradein.priceQuote
            ? JSON.parse(tradein.priceQuote).PriceQuoteId
            : null,
          co2Emission: tradein.co2Emission,
          dueDiligenceCheck: tradein.priceQuote
            ? JSON.parse(tradein.priceQuote).DueDiligenceCheckId
            : null,
          userInputValue: tradein.userInputValue || null,
        };
      }),
      total: Math.round(totalValue),
      registeredId: null,
      status: null,
    },
  };

  return formattedData;
}

document.addEventListener("DOMContentLoaded", () => {
  // Initialize global trade-in state
  initializeGlobalTradeInState();

  // Initialize trade-in item parsing when DOM is loaded
  // Check if we're on the cart page
  const isCartPage = window.location.pathname.includes("/cart");

  if (!isCartPage) {
    return;
  }

  parseAndRenderTradeInItems();
});

// ------- Init Trade-in combobox (only if elements exist) -------
document.addEventListener("DOMContentLoaded", () => {
  // Initialize global trade-in state
  initializeGlobalTradeInState();

  // Debounce helper (scoped locally)
  const debounce = (fn, ms = 250) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  const input = globalTradeInState.input;
  const list = document.querySelector("#tradein-listbox");
  const hidden = globalTradeInState.hidden;
  const combo = globalTradeInState.combo;

  if (!input || !list || !hidden || !combo) return; // Not present on this page

  let options = []; // senaste träffar
  let activeIndex = -1;

  // ------- Rendera listan -------
  function renderList(items) {
    list.innerHTML = "";
    options = items || [];
    activeIndex = -1;
    combo.setAttribute("aria-expanded", String(options.length > 0));

    options.forEach((m, i) => {
      const div = document.createElement("div");
      div.className = "tradein-option";
      div.setAttribute("role", "option");
      div.setAttribute("id", `tradein-opt-${m.Id}`);
      div.dataset.id = m.Id;

      const label =
        m.ProductName || m.ProductNameShort || m.ItemName || "Okänd modell";
      div.textContent = label;

      // mousedown för att inte tappa fokus före click
      div.addEventListener("mousedown", (e) => {
        e.preventDefault();
        selectModel(i);
      });

      list.appendChild(div);
    });

    // sätt höjd när dropdown är fokus
    if (items.length !== 0) {
      document
        .getElementsByClassName("tradein-combobox")[0]
        .classList.add("trade-in-open-dropdown");
    }
  }

  // ------- Hämta träffar -------
  const searchModels = debounce(async (term) => {
    if (!term || term.trim().length < 2) {
      renderList([]);
      return;
    }

    // term kan vara modellnamn, serienummer eller IMEI (enligt Foxway).
    // GET /api/v2/rework?path=retail/models?term=...
    const path = `retail/models?term=${encodeURIComponent(term)}`;

    const res = await fetchRework(path); // Din helper
    // Förväntat svar enligt docs: { Data: [ { Id, ProductName, PictureUrl, Price, ... } ] }
    const items = res?.Data || [];
    renderList(items);
  }, 250);

  // ------- Välj modell -------
  async function selectModel(idx) {
    const m = options[idx];
    if (!m) return;

    // Spara värdet användaren skrev innan input uppdateras
    globalTradeInState.userInputValue = input.value || "";

    // Sätt UI
    input.value = m.ProductName || m.ProductNameShort || m.ItemName;
    hidden.value = m.Id;
    renderList([]);

    // Hämta modellinformation och grading-form enligt Foxway API
    try {
      // GET /api/v2/rework?path=retail/models/{id}
      const modelInfo = await fetchRework(`retail/models/${m.Id}`);
      if (modelInfo) {
        input.dataset.price = modelInfo.Price || 0;
        input.dataset.productName = modelInfo.ProductName || m.ProductName;
      }

      // GET /api/v2/rework?path=retail/models/{id}/grading-form
      const grading = await fetchRework(`retail/models/${m.Id}/grading-form`);
      if (grading) {
        input.dataset.gradingForm = JSON.stringify(grading);
        // Skapa initiala svar för grading form
        const answers = {};
        if (grading.Questions && grading.Questions.length) {
          grading.Questions.forEach((question, index) => {
            answers[index] = [0];
          });
        }
        input.dataset.answers = JSON.stringify(answers);

        // Skapa initial price quote
        const payload = {
          GradingForm: {
            Answers: answers,
          },
          ModelId: m.Id,
          ItemIdentifier: input.value.length > 4 ? input.value : null,
        };

        let priceQuote = await postRework("retail/price-quote", payload);

        if (priceQuote) {
          input.dataset.priceQuote = JSON.stringify(priceQuote);
          input.dataset.offeredPrice = priceQuote.OfferedPrice || 0;

          // Visa grading form
          renderGradingForm(grading);

          // Hämta CO2 emission
          if (priceQuote.PriceQuoteId) {
            const co2Emission = await fetchCo2Emission(priceQuote.PriceQuoteId);
            input.dataset.co2Emission = co2Emission;
          }
        }
      }
    } catch (error) {
      console.error("Error fetching model data:", error);
    }
  }

  function updateActive() {
    [...list.children].forEach((el, i) => {
      el.classList.toggle("is-active", i === activeIndex);
      el.setAttribute("aria-selected", String(i === activeIndex));
      if (i === activeIndex) el.scrollIntoView({ block: "nearest" });
    });
  }

  // ------- Tangentbord -------
  input.addEventListener("keydown", (e) => {
    const max = options.length - 1;
    if (!options.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      activeIndex = Math.min(max, activeIndex + 1);
      updateActive();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      activeIndex = Math.max(0, activeIndex - 1);
      updateActive();
    } else if (e.key === "Enter" && activeIndex >= 0) {
      e.preventDefault();
      selectModel(activeIndex);
    } else if (e.key === "Escape") {
      renderList([]);
    }
  });

  // ------- Inputlyssnare -------
  input.addEventListener("input", (e) => searchModels(e.target.value));
  input.addEventListener("focus", () => {
    if (options.length) combo.setAttribute("aria-expanded", "true");
  });
  document.addEventListener("click", (e) => {
    if (!combo.contains(e.target)) renderList([]);
  });

  // ------- Grading form funktioner -------
  async function updateGradingValue(questionIndex) {
    const modelId = hidden.value;
    if (!modelId) return;

    let question = "question-" + questionIndex;
    let isChecked = document.getElementById(question).checked;

    try {
      const currentAnswers = JSON.parse(input.dataset.answers || "{}");
      currentAnswers[questionIndex] = [isChecked ? 1 : 0];
      input.dataset.answers = JSON.stringify(currentAnswers);

      const payload = {
        GradingForm: {
          Answers: currentAnswers,
        },
        ModelId: modelId,
      };

      let priceQuote = await postRework("retail/price-quote", payload);

      if (priceQuote) {
        input.dataset.priceQuote = JSON.stringify(priceQuote);
        input.dataset.offeredPrice = priceQuote.OfferedPrice || 0;
        // Uppdatera UI med nytt pris
        updatePriceDisplay(priceQuote.OfferedPrice);
      }
    } catch (error) {
      console.error("Error updating grading value:", error);
    }
  }

  // ------- Rendera grading form -------
  function renderGradingForm(gradingForm) {
    const formContainer = document.getElementById("tradein-grading-form");
    if (!formContainer || !gradingForm || !gradingForm.Questions) return;

    formContainer.style.display = "block";
    formContainer.innerHTML = "";

    // Lägg till "Allt är bra" alternativ
    const allGoodDiv = document.createElement("div");
    allGoodDiv.className = "tradein-all-good";
    allGoodDiv.innerHTML = `
      <div id="tradein-grading-form-all-good">
      <div class="tradein-all-good-title">
        <span>Är enheten i gott skick?</span>
        <span>Svara ja om alla dessa påståenden stämmer:</span>
      </div>
        <ul>
          <li>Enheten startar upp och fortsätter utan laddare</li>
          <li>
            Enheten är komplett, inga delar saknas, knappar finns och är fungerande
          </li>
          <li>
              Skärmen är fullt fungerande och i perfekt skick. Ingen beläggning, inga repor eller pixeldefekter

          </li>
          <li>
            Det finns inga sprickor, eller skador på skärmen, ramen eller bakstycket
          </li>
          <li>Inga obehöriga delar eller modifieringar har använts</li>
        </ul>
        <div class="tradein-check-btn-wrapper">
          <div id="tradein-check-btn-active" class="tradein-check-btn-active"></div>
          <div style="color:#3f3c39" id="check-yes-btn" class="tradein-check-btn-default" onclick="setAllGood(true)">
            <span>Ja</span>
          </div>
          <div id="check-no-btn" class="tradein-check-btn-default" onclick="setAllGood(false)">
            <span>Nej</span>
          </div>
        </div>
      </div>
    `;

    formContainer.appendChild(allGoodDiv);

    // Lägg till individuella frågor
    gradingForm.Questions.forEach((question, index) => {
      const questionDiv = document.createElement("div");
      questionDiv.className =
        "tradein-question tradein-grading-form-question-hidden";
      questionDiv.innerHTML = `
        <h4>${question.Name}</h4>
        ${
          question.InfoCards
            ? question.InfoCards.map(
                (card) => `<div class="tradein-info-card">${card.Text}</div>`
              ).join("")
            : ""
        }
        <div class="tradein-check-btn-wrapper">
          <div id="tradein-check-btn-active-${index}" class="tradein-check-btn-active"></div>
          <div style="color:#3f3c39" id="check-yes-btn-${index}" class="tradein-check-btn-default" onclick="updateGradingValueWithButton(${index}, true)">
            <span>Ja</span>
          </div>
          <div style="color:#e5e5e5" id="check-no-btn-${index}" class="tradein-check-btn-default" onclick="updateGradingValueWithButton(${index}, false)">
            <span>Nej</span>
          </div>
        </div>
      `;
      formContainer.appendChild(questionDiv);
    });

    // Lägg till prisvisning
    const priceDiv = document.createElement("div");
    priceDiv.className = "tradein-price-display";
    priceDiv.innerHTML = `<div class="tradein-price-text"><span>Uppskattat inbytesvärde:</span> <strong>${formatSwedishNumber(
      input.dataset.offeredPrice || 0
    )} SEK*</strong></div>`;
    priceDiv.innerHTML += `
      <div class="tradein-price-disclaimer">
        * Observera att värderingen som utförs på denna sida ger ett uppskattat inbytesvärde. Det slutgiltiga värdet avgörs samt krediteras din valda betalmetod när vi tagit emot din inbytesenhet och bekräftat enhetens skick.
      </div>
    `;
    formContainer.appendChild(priceDiv);

    // Lägg till CO2 information om tillgänglig
    if (input.dataset.co2Emission) {
      const co2Div = document.createElement("div");
      co2Div.className = "tradein-co2-info";
      co2Div.textContent = `CO2 besparing: ${input.dataset.co2Emission} kg`;
      formContainer.appendChild(co2Div);
    }
    document
      .getElementsByClassName("tradein-combobox")[0]
      .classList.remove("trade-in-open-dropdown");

    const footerDiv = document.createElement("div");
    footerDiv.className = "tradein-footer";
    footerDiv.innerHTML = `
      <div class="tradein-footer">
        <button onclick="addTradein()" class="button button--primary">Lägg till</button>
      </div>
      `;
    formContainer.appendChild(footerDiv);
  }

  // Exponera funktioner globalt för användning i HTML
  window.updateGradingValue = updateGradingValue;
  window.updateGradingValueWithButton = updateGradingValueWithButton;
});

// ------- Refresh Trade-In Items Function -------
function refreshTradeInItems() {
  // Check if we're on the cart page
  const isCartPage = window.location.pathname.includes("/cart");
  if (!isCartPage) {
    return;
  }

  // Re-parse and render trade-in items
  parseAndRenderTradeInItems();

  // Update cart price displays
  updateCartPriceDisplays();
}

// Expose functions to global scope immediately (not waiting for DOMContentLoaded)
window.setAllGood = setAllGood;
window.performDueDiligenceCheck = performDueDiligenceCheck;
window.fetchCo2Emission = fetchCo2Emission;
window.addTradein = addTradein;
window.resetTradeinForm = resetTradeinForm;
window.removeTradeinInstance = removeTradeinInstance;
window.updateGradingValueForInstance = updateGradingValueForInstance;
window.setAllGoodForInstance = setAllGoodForInstance;
window.toggleTradeinDropdown = toggleTradeinDropdown;
window.updatePriceContainers = updatePriceContainers;
window.updateCartPriceDisplays = updateCartPriceDisplays;
window.getFormattedTradeInData = getFormattedTradeInData;
window.parseAndRenderTradeInItems = parseAndRenderTradeInItems;
window.removeTradeInItem = removeTradeInItem;
window.updateCartWithTradeInData = updateCartWithTradeInData;
window.refreshTradeInItems = refreshTradeInItems;

// ------- M-Art Update on URL Change -------
function getProductHandleFromUrl(url = window.location.pathname) {
  const match = url.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

/**
 * Fetches product metafield via Shopify Product JSON API
 * Note: Metafields must be exposed in Storefront API settings
 */
async function fetchProductMArt(handle) {
  if (!handle) return null;

  try {
    const response = await fetch(`/products/${handle}.json`);
    if (!response.ok) return null;

    const data = await response.json();
    const product = data.product;

    if (product?.variants?.[0]?.metafields) {
      const mArtMetafield = product.variants[0].metafields.find(
        (mf) => mf.namespace === "custom" && mf.key === "macforum_artnr"
      );
      return mArtMetafield?.value || null;
    }

    return null;
  } catch (error) {
    console.error("Error fetching M-Art:", error);
    return null;
  }
}

/**
 * Updates M-Art display elements on the page
 */
function updateMArtDisplay(mArtValue) {
  const mArtElements = document.querySelectorAll(".m-art-pdp");

  mArtElements.forEach((el) => {
    if (mArtValue) {
      el.textContent = `M-Art: ${mArtValue}`;
      el.style.display = "";
    } else {
      el.style.display = "none";
    }
  });
}

/**
 * Handles URL change and updates M-Art
 * Called after variant/product change via AJAX
 */
async function handleUrlChangeForMArt() {
  const handle = getProductHandleFromUrl();
  if (!handle) return;

  const mArtValue = await fetchProductMArt(handle);
  if (mArtValue) {
    updateMArtDisplay(mArtValue);
  }
}

document.addEventListener("productUrlChanged", handleUrlChangeForMArt);

window.getProductHandleFromUrl = getProductHandleFromUrl;
window.fetchProductMArt = fetchProductMArt;
window.updateMArtDisplay = updateMArtDisplay;
window.handleUrlChangeForMArt = handleUrlChangeForMArt;
